export default "__VITE_ASSET__LJ_ihV24__"